import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import PageTitle from "../../../pageTitleConfig";
import TabsSection from "./tabsSection";
import ProfileSection from "./profileSection";

import { useSubheader } from "../../../../_metronic/layout";

const ClinicalGroupsPage = (props) => {
  const history = useHistory();
  const suhbeader = useSubheader();
  suhbeader.setTitle("Clinical Group");

  return (
    <>
      <Helmet>
        <title>{PageTitle.CLINICAL_GROUP_LIST}</title>
      </Helmet>
      <div className="row">
        <div className="col-md-12">
          <ProfileSection />
        </div>
        <div className="col-md-12">
          <TabsSection />
        </div>
      </div>
    </>
  );
};
export default ClinicalGroupsPage;
